import isFunction from "lodash/isFunction"
import { compose } from "recompact"

export default function combinePlugins(...plugins) {
  const result = {}
  for (let i = 0; i < plugins.length; i += 1) {
    // eslint-disable-next-line
    for (const prop in plugins[i]) {
      if (
        Object.prototype.hasOwnProperty.call(plugins[i], prop) &&
        isFunction(plugins[i][prop])
      ) {
        if (result[prop]) {
          result[prop] = compose(result[prop], plugins[i][prop])
        } else {
          result[prop] = plugins[i][prop]
        }
      }
    }
  }

  return result
}
